import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { LoadingItemDesktop } from './desktop';
import { LoadingItemMobile } from './mobile';
import { LoadingItemTablet } from './tablet';

export const ResposiveLoadingItem = () => {
  const loadingComponent = useBreakpointValue({
    base: <LoadingItemMobile />,
    sm: <LoadingItemTablet />,
    lg: <LoadingItemDesktop />,
  });

  return loadingComponent;
};
